import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const Item = (props) => {
  const [reg, setReg] = useState({});
  const [status, setStatus] = useState({});
  const [block, setBlock] = useState(false);
  const { fullList, list } = useSelector((state) => state);
  const getItem = useCallback(async () => {
    if (fullList) {
      fullList.forEach((el) => {
        el.forEach((element) => {
          if(props.item.regionId && element.id === props.item.regionId){
            setReg(element);
          }else if (!props.item.regionId && props.item.organisation && element.id === props.item.organisation.regionId) {
            setReg(element);
          }
        });
      });
    }
  }, [fullList]);

  const getActualStatusList =(category)=>{
    let arr = [];
    let prevArr = [];
    if(category<2){
      // arr[0]=fullList[4][0];
      // arr[1]=fullList[4][1];
      arr[2]=fullList[4][2];
      arr[3]=fullList[4][6];
      arr[4]=fullList[4][5];
      arr[5]=fullList[4][8];
      arr[6]=fullList[4][9];
      arr[7]=fullList[4][15];
      arr[8]=fullList[4][14];
      arr[9]=fullList[4][17];
      arr[10]=fullList[4][18];
      arr[11]=fullList[4][19];
      arr[12]=fullList[4][20];
      arr[13]=fullList[4][21];
      arr[14]=fullList[4][22];
    }else{
      // arr[0]=fullList[4][0];
      // arr[1]=fullList[4][1];
      arr[2]=fullList[4][2];
      arr[3]=fullList[4][11];
      arr[4]=fullList[4][10];
      arr[5]=fullList[4][13];
      arr[6]=fullList[4][15];
      arr[7]=fullList[4][14];
      arr[8]=fullList[4][17];
      arr[9]=fullList[4][18];
      arr[10]=fullList[4][19];
      arr[11]=fullList[4][20];
      arr[12]=fullList[4][21];
      arr[13]=fullList[4][22];
    }
    return arr;
  }

  const getNosology = (nosologyId) => {
    const nosology = fullList[1].filter((item) => item.id === nosologyId).pop();
    return nosology ? nosology.shortTitle : '';
  };

  const openList = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (block) {
      setBlock(false);
    } else {
      setBlock(true);
    }
  };
  const getStatus = useCallback(async () => {
    if (fullList && fullList[4]) {
      fullList[4].forEach((el) => {
        if (el.status === props.item.status) {
          setStatus(el);
        }
      });
    }
  }, [fullList]);

  useEffect(() => {
    getItem(fullList);
    getStatus(fullList);
  }, [fullList]);

  const clickHandler = (event) => {
    if (event.target.nodeName !== 'INPUT') {
      props.history.push(`/applicationsItem/${event.currentTarget.id}`);
    }
  };

  let currDate = new Date();
  let prevDate = new Date(props.item.updatedAt);
  let diff = new Date(currDate.getTime() - prevDate.getTime());

  return (
    <tr id={props.item.id}>
      <td>
        {props.item.datePublished
          ? new Date(props.item.datePublished).toLocaleString('uk-UA', {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric',
            })
          : ''}
      </td>
      <td>
        {props.item.athleteLastName
          ? props.item.athleteLastName +
            ' ' +
            props.item.athleteFirstName +
            ' ' +
            props.item.athleteSecondName
          : '---'}{' '}
        <br />
        <span className="application-span" onClick={openList}>
          {status.title}{' '}
          {diff.getUTCFullYear() - 1970 > 0 && <>{diff.getUTCFullYear() - 1970}'років'</>}
          {diff.getUTCMonth() > 0 && <>{diff.getUTCMonth()} м.</>}
          {diff.getUTCDate() - 1 > 0 && <>({diff.getUTCDate() - 1}д.)</>}{' '}
        </span>
        {block && (
          <div className="application-block" onMouseLeave={(e) => setBlock(false)}>
            {getActualStatusList(props.item.sportCategoryType).map((el,index)=>{
              const currentStatusIndex = getActualStatusList(props.item.sportCategoryType).findIndex(elem => elem?.status == props?.item?.status);            
            if (index === currentStatusIndex) {
                return (
                  <span style={{ fontWeight: 'bold' }} className="application-block-item">
                    {' '}
                    {el.title}
                    <br />{' '}
                  </span>
                );
            }else if(index> currentStatusIndex){
              return (
                <span className="application-block-item">
                {' '}
                {el.title}
                <br />{' '}
              </span>)
            }else if (index<currentStatusIndex){
              return (
              <span style={{ color: '#C2C5CB' }} className="application-block-item">
              {' '}
              {el.title} 
             
              <br />{' '}
              {props?.item?.applicationsSignatory?.map((element,index)=>{
                if(element.status==el.status && element.lastName.length>0){
                  return(
                    <span style={{ color: 'black' }}> {element.lastName  + ' ' + element.firstName} </span> 
                    )
                }
              })}
              </span>)
            }
          })};
          </div>
        )}
      </td>
      <td>
        {props.item.sex?list[props.item.sex]:'---'}
      </td>
      <td>
        {props.item.athleteCategoryTitle ? props.item.athleteCategoryTitle.split('/')[0] : '---'}
        <br />
        <span style={{color:'grey'}}>
          {props.item.sportCategoryId!=='f925fa34-258b-4d60-a604-eca9b027596f' && props.item.sportCategoryId!== '37a14ca2-4b35-4d3c-a180-4340338ab4eb' && props.item.sportCategoryId!=='1a5066b7-3dea-4fa1-8c16-dd5a449cb317' && fullList?.length>0 && getNosology(props.item.sportCategoryId)} 
        </span>

      </td>
      <td>{props.item.sportTitle ? props.item.sportTitle : '---'}
      </td>
      <td>
        {props.item && props.item.organisation && props.item.organisation.shortName
          ? props.item.organisation.shortName
          : '---'}{' '}
      </td>
      <td>
        {list[props.item.company] || props.item.company ||'---'}
      </td>
      <td>{reg.title ? reg.title : '---'}</td>
      <td>
        {props.item?.tournamentConfirmationDocumentUrl?.length > 0 && (
          <button
            className="icon-text-btn-secondary publicIcon"
            onClick={() => window.open(props.item.tournamentConfirmationDocumentUrl)}
          >
            Протокол&nbsp;змагань
          </button>
        )}{' '}
      </td>
    </tr>
  );
};

export default Item;
